import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';

class PushapiCpc extends Component {
    constructor() {
        super();

        this.state = {
            report: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleFieldChange(event) {
        const { value, name } = event.target;

        this.setState({ [name]: value });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        API.PushapiCpc.getReport(filters, type).then(({ report }) => this.setState({ report, isLoading: false }));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getTable() {
        const { report } = this.state;

        return report.length ?
            <Table report={report} onSortChange={this.handleSort} /> :
            <p>No Data</p>
    }

    render() {
        const { isLoading } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Pushapi Cpc"/>
                <Form onSubmit={this.handleSubmit}/>

                {this.getTable()}

            </Container>
        );
    }
}

export default PushapiCpc;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCpc/index.js